import type { RouteRecordRaw } from 'vue-router'

import CartView from '@/modules/order/views/CartView.vue'
import CheckoutView from '@/modules/order/views/CheckoutView.vue'

export const orderRoutes: RouteRecordRaw[] = [
  {
    path: '/cart',
    name: 'cart',
    component: CartView,
    meta: { title: 'Корзина', blockSupplier: true },
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: CheckoutView,
    meta: {
      title: 'Оформление заказа',
      requiresAuth: true,
      blockSupplier: true,
    },
  },
]
